import {CommonRootState} from '../types';
import {StaffElevationState} from './index';

const NOT_ELEVATED: StaffElevationState = {
  token: null,
  expiresAt: null,
  required: false,
};

/**
 * The slice. `CommonRootState` types it as always present, and in production
 * it is (each app's coreSliceContract test asserts the registration). The
 * read below deliberately does not trust that: many app test harnesses build
 * partial stores, and every request goes through here, so an absent slice
 * reads as "not elevated" -- the request goes out without the header and the
 * backend decides -- rather than throwing inside useApiClient.
 */
export const selectStaffElevation = (
  state: CommonRootState,
): StaffElevationState =>
  (state as Partial<CommonRootState>).staffElevation ?? NOT_ELEVATED;

/** The token to send, or null when none is held or it has expired. */
export const activeStaffElevationToken = (
  {token, expiresAt}: StaffElevationState,
  nowSeconds: number,
): string | null =>
  token !== null && expiresAt !== null && expiresAt > nowSeconds ? token : null;
